var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.8802 0 0 17.8802 0 40C0 62.1198 17.8802 80 40 80C62.1198 80 80 62.1198 80 40C80 17.8802 62.1198 0 40 0ZM59.3548 31.7051L35.6682 55.2995C34.9308 56.037 34.0095 56.4053 33.0876 56.4053C32.1656 56.4053 31.1517 56.037 30.5069 55.2995L18.8017 43.6863C17.3269 42.2115 17.3269 39.9073 18.8017 38.4325C20.2765 36.9577 22.5806 36.9577 24.0555 38.4325L33.0876 47.4646L54.1014 26.4508C55.5762 24.976 57.8804 24.976 59.3552 26.4508C60.7374 27.9262 60.7374 30.3223 59.3552 31.7052L59.3548 31.7051Z",
    fill: "#7AD81B",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccess);
export default __webpack_public_path__ + "static/media/check-success.170e12c1a0e515e205bc0ec909a8ff70.svg";
export { ForwardRef as ReactComponent };